import { app } from '../../../../../../app';
import { Controller } from './move-accounts-to-group.controller';

app.component('companyUserDirectoriesManageGroupAccountsMove', {
    bindings: {
        accounts: '<',
        companyId: '<',
        group: '<',
        groups: '<',
    },
    controller: Controller,
    templateUrl: require('./move-accounts-to-group.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/move/move-accounts-to-group.component.js